export var thirdPartyColors = {};